import { render } from "./WilcomLetteringPrototype.vue?vue&type=template&id=a35db822&scoped=true"
import script from "./WilcomLetteringPrototype.vue?vue&type=script&lang=js"
export * from "./WilcomLetteringPrototype.vue?vue&type=script&lang=js"

import "./WilcomLetteringPrototype.vue?vue&type=style&index=0&id=a35db822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35db822"]])

export default __exports__